module.exports = __webpack_public_path__ + "img/role.c39de2eb.png";